function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tasks from '@/js/tasks';
import DialogsComponent from '@/components/DialogsComponent';
import CalendarComponent from '@/components/CalendarComponent';
import AddBaseIdsComponent from '@/apps/attributes/modules/use_cases/components/AddBaseIdsComponent';
import { useCaseMixin } from '@/apps/attributes/mixins/use_case_mixin';
import { mapState, mapMutations, mapGetters } from 'vuex';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import rolesService from '@/apps/data-platform/services/master_data/role_service';
import { ARRAY_TYPE_ELEMENTS, TYPE_ELEMENTS, ROLES_LIST, GA_EVENTS } from '@/js/constants';
export default {
  name: 'SandboxRequest',
  components: {
    DialogsComponent: DialogsComponent,
    AddBaseIdsComponent: AddBaseIdsComponent,
    CalendarComponent: CalendarComponent
  },
  mixins: [useCaseMixin],
  created: function created() {
    // si el companyCode ya vino del store antes de montar el componente
    this.initStepper();
  },
  data: function data() {
    return {
      stepperReady: false,
      DIALOG_CANCEL_SANDBOX_REQUEST: 'DIALOG_CANCEL_SANDBOX_REQUEST',
      COLOR_STEP_PRIMARY: '#999999',
      COLOSER_STEP_SUCCESS: '#1CCF78',
      newUsers: [],
      owner_email: window.userInfo.email,
      ATRIBUTE_ADMIN: ['attribute_admin'],
      INTERCORP_DOMAIN: 'intercorp.com.pe',
      env_user_admin_group: {},
      valid: true,
      fecha_id: 0,
      fecha_custom: '',
      fechas: [{
        id: 1,
        name: '1 mes'
      }, {
        id: 2,
        name: '2 meses'
      }, {
        id: 3,
        name: '3 meses'
      }, {
        id: 6,
        name: '6 meses'
      }],
      dateItem: null,
      menu: false,
      modal: false,
      color_step_1: '#999999',
      color_step_2: '#999999',
      color_step_3: '#999999',
      item: {
        'use_case': 'Modelo de Inferencia de Ingresos',
        'scenario': 'Atributos transformados',
        'date_created': '15/06/2022',
        'attributes': '300/-',
        'status': 'ACTIVE',
        'finished': false
      },
      DIALOG_ADD_BASE_IDS: 'DIALOG_ADD_BASE_IDS',
      baseIDS: [],
      list_buttons: [{
        title: this.translate('attributes.button.by_word'),
        path: '/attributes/search'
      }, {
        title: this.translate('attributes.button.by_group'),
        path: '/attributes/groups'
      }]
    };
  },
  beforeMount: function beforeMount() {
    this.precargarOwner();
    this.precargarAdmins();
    if (!this.useCaseRequest) {
      this.setUseCaseRequest({
        step: '01',
        business_name: '',
        description_business: '',
        baseIDS: [],
        attributes: [],
        env_user_group: {}
      });
    }
  },
  watch: _defineProperty({
    'useCaseRequest.business_name': function useCaseRequestBusiness_name(newVal) {
      this.useCaseRequest.business_name = newVal.toLowerCase();
    },
    companyCode: {
      // se dispara cuando llegue el código
      immediate: true,
      // y también en el primer render
      handler: function handler() {
        this.initStepper();
      }
    }
  }, "useCaseRequest.business_name", function useCaseRequestBusiness_name(val) {
    if (this.useCaseRequest) this.useCaseRequest.business_name = val.toLowerCase();
  }),
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState('attribute', ['attributes', 'useCaseRequest', 'companyAbrevs', 'businessUserServiceAccounts', 'flagCustomExpirationSbx'])), mapState('data-platform', ['companyCode', 'companyName'])), mapGetters('attribute', ['getUseCaseRequestBaseIDS'])), {}, {
    rules: function rules() {
      var _this = this;
      return {
        businessName: [function (v) {
          return !!v || _this.translate('reglas.nombre');
        }, function (v) {
          return v && v.length >= 3 || _this.translate('reglas.nombre_min');
        }, function (v) {
          return v && v.length <= 15 || _this.translate('reglas.nombre_max_15');
        }, function (v) {
          return /^[a-z0-9_]+$/i.test(v) || _this.translate('reglas.nombre_formato');
        }, function (v) {
          return _this.technicalNameRule(v);
        }, function (v) {
          return !/[<>"'`]/.test(v) || 'No se permiten caracteres especiales como <, >, ", \', `';
        }, function (v) {
          return !/onerror\s*=|script\s*>|<script/i.test(v) || 'Texto inválido detectado';
        }],
        period: [function (v) {
          return !!v || _this.translate('reglas.period');
        }],
        serviceAccount: [function (v) {
          return !!v || _this.translate('reglas.field');
        }],
        businessDescription: [function (v) {
          return !!v || _this.translate('reglas.field');
        }, function (v) {
          return !/[<>"'`]/.test(v) || 'No se permiten caracteres especiales como <, >, ", \', `';
        }, function (v) {
          return !/onerror\s*=|script\s*>|<script/i.test(v) || 'Texto inválido detectado';
        }]
      };
    },
    sandbox_stepper: {
      get: function get() {
        return this.useCaseRequest && this.useCaseRequest.step ? this.useCaseRequest.step : '01';
      },
      set: function set(value) {
        this.updateUseCaseRequest({
          property: 'step',
          value: value
        });
      }
    },
    bannerStyle: function bannerStyle() {
      var step = parseInt(this.sandbox_stepper);
      return {
        '--color_step_1': step > 1 ? this.COLOSER_STEP_SUCCESS : this.COLOR_STEP_PRIMARY,
        '--color_step_2': step >= 2 ? this.COLOSER_STEP_SUCCESS : this.COLOR_STEP_PRIMARY
      };
    },
    composeNameBaseID: function composeNameBaseID() {
      return function () {
        var baseID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (baseID) {
          text = "".concat(baseID.table.projectId, ".").concat(baseID.table.datasetId, ".").concat(baseID.table.objectId);
        }
        return text;
      };
    },
    label: function label() {
      return {
        use_case_name: this.translate('attributes.label.use_case_name'),
        duration: this.translate('attributes.label.duration'),
        detail_use_case: this.translate('attributes.label.detail_use_case'),
        add_sa_by_business_area: this.translate('attributes.label.add_sa_by_business_area'),
        users: this.translate('attributes.label.users')
      };
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('attribute', ['updateUseCaseRequest', 'setUseCaseRequest', 'setAttributes'])), mapMutations('app', ['setShowLoading'])), {}, {
    onCancelRequest: function onCancelRequest(confirm) {
      if (confirm) {
        this.setUseCaseRequest(null);
        this.setAttributes([]);
        this.updateUseCaseRequest({
          property: 'step',
          value: '01'
        });
      }
      this.$refs[this.DIALOG_CANCEL_SANDBOX_REQUEST].onClose();
    },
    initStepper: function initStepper() {
      // si aún no tenemos el valor, esperamos
      if (!this.companyCode) return;

      // elegimos el paso inicial
      this.sandbox_stepper = this.companyCode === '000' ? '02' : '01';

      // ahora sí mostramos el stepper (sin parpadeo)
      this.stepperReady = true;
    },
    technicalNameRule: function technicalNameRule(value) {
      if (this.isIbkDomain()) {
        if (value.includes(' ')) {
          return 'Los espacios no son requeridos';
        } else {
          return true;
        }
      }
      return true;
    },
    goToSearch: function goToSearch() {
      this.$router.push('/attributes/search/');
    },
    click_sandobx_stepper: function click_sandobx_stepper(valor) {
      var _this2 = this;
      console.log('company code', this.companyCode);
      var etapa = parseInt(valor);
      switch (etapa) {
        case 1:
          this.color_step_1 = '#999999';
          this.color_step_2 = '#999999';
          this.color_step_3 = '#999999';
          break;
        case 2:
          // ir a paso 2
          if (this.attributes.length === 0 && this.companyCode !== '000') {
            tasks.toast.info(this.translate('error_messages.min_attribute_selection'), 'Información');
            return;
          }
          this.color_step_1 = '#1CCF78';
          this.color_step_2 = '#999999';
          this.color_step_3 = '#999999';
          this.onSelectAttributes();
          break;
        case 3:
          // ir a paso 3
          if (!this.$refs.form.validate() || this.errors.length > 0) {
            var _iterator = _createForOfIteratorHelper(this.$refs.form.$children),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var el = _step.value;
                if (el.valid === false) {
                  el.focus();
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return;
          }
          this.color_step_1 = '#1CCF78';
          this.color_step_2 = '#1CCF78';
          this.color_step_3 = '#999999';
          this.onRegisterUseCase();
          this.onFinishRequest().then(function () {
            tasks.toast.success(_this2.translate('success_messages.general'), _this2.translate('titles.success'), 'ownership_history');
            _this2.setUseCaseRequest(null);
            _this2.setAttributes([]);
          }).catch(function (error) {
            var message = _this2.translate('error_messages.register_use_case'); // Mensaje por defecto
            if (error && error.response && error.response.data && error.response.data.data && error.response.data.data.error_info) {
              message = error.response.data.data.error_info;
            } else if (error && error.response && error.response.data && error.response.data.message) {
              message = error.response.data.message;
            } else if (error && error.message) {
              message = error.message;
            }
            tasks.toast.error(message, _this2.translate('titles.error'));
            _this2.updateUseCaseRequest({
              property: 'step',
              value: '02'
            });
            _this2.setShowLoading(false);
          });
        // break
        // case 4:// ir a paso 4
        //   this.color_step_1 = '#1CCF78'
        //   this.color_step_2 = '#1CCF78'
        //   this.color_step_3 = '#1CCF78'
        //   this.onFinishRequest().then(() => {
        //     tasks.toast.success(this.translate('success_messages.general'), this.translate('titles.success'), 'ownership_history')
        //     this.setUseCaseRequest(null)
        //     this.setAttributes([])
        //   }).catch(() => {
        //     tasks.toast.error(this.translate('error_messages.register_use_case'), this.translate('titles.error'))
        //     this.updateUseCaseRequest({ property: 'step', value: '02' })
        //     this.setShowLoading(false)
        //   })
        //   break
      }
      this.sandbox_stepper = valor;
    },
    onSelectAttributes: function onSelectAttributes() {
      var rDetail = this.attributes.map(function (item) {
        return {
          attribute_name: item.nombre,
          attribute_object_name: item.tabla,
          attribute_scheme_name: item.dataset,
          attribute_project_name: item.proyecto,
          attribute_description: item.descripcion,
          is_partyid: '0',
          is_external: '0',
          attribute_source_id: 3,
          attribute_filters: item.filters ? item.filters : {},
          attribute_category: item.categoria,
          attribute_dtype: item.tipo_dato,
          attribute_notnull: item.no_nulo
        };
      });
      this.updateUseCaseRequest({
        property: 'attributes',
        value: rDetail
      });
    },
    onRegisterUseCase: function onRegisterUseCase() {
      console.log('this.fecha_custom', this.fecha_custom);
      var envUserGroup = {
        email: {}
      };
      this.newUsers.forEach(function (item, index) {
        envUserGroup['email'][index.toString()] = item;
      });
      this.useCaseRequest.technical_name = this.useCaseRequest.business_name;
      var fecha = new Date();
      fecha = new Date(fecha.setMonth(fecha.getMonth() + this.fecha_id));
      if (this.flagCustomExpirationSbx && this.fecha_custom) {
        var _this$fecha_custom$sp = this.fecha_custom.split('-').map(Number),
          _this$fecha_custom$sp2 = _slicedToArray(_this$fecha_custom$sp, 3),
          y = _this$fecha_custom$sp2[0],
          m = _this$fecha_custom$sp2[1],
          d = _this$fecha_custom$sp2[2];
        fecha = new Date(y, m - 1, d);
      }
      this.useCaseRequest.access_deadline_date = fecha;
      console.log("🕛🕛⏰fecha", this.useCaseRequest.access_deadline_date);
      this.useCaseRequest.env_user_group = envUserGroup;
      this.setUseCaseRequest(this.useCaseRequest);
    },
    onAddBaseID: function onAddBaseID(useCase, baseID) {
      // Check if base was already registered
      var baseIDtoCheck = this.baseIDS.find(function (item) {
        return item.table.id === baseID.table.id;
      });
      this.$refs[this.DIALOG_ADD_BASE_IDS].onClose();
      if (baseIDtoCheck) {
        tasks.toast.error(this.translate('error_messages.duplicate_base'));
        return;
      }
      this.baseIDS.push(baseID);
      useCase.baseIDS = this.baseIDS;
      this.setUseCaseRequest(useCase);
    },
    onRemoveBaseID: function onRemoveBaseID(baseID) {
      var baseIdIndex = this.baseIDS.findIndex(function (item) {
        return item.table.id === baseID.table.id;
      });
      if (baseID !== -1) {
        this.baseIDS.splice(baseIdIndex, 1);
        this.updateUseCaseRequest({
          property: 'baseIDS',
          value: this.baseIDS
        });
      }
    },
    onFinishRequest: function onFinishRequest() {
      var _this3 = this;
      this.setShowLoading(true);
      var deadline = this.useCaseRequest.access_deadline_date;
      console.log("🕛🕛⏰deadline", deadline);
      var today = new Date();
      console.log("today:: ", today);
      // Normalizamos las horas para que no afecten al cálculo de días
      deadline.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      // Diferencia en milisegundos
      var diffTime = deadline - today;

      // Convertimos a días
      var expiration_days = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      console.log("Quedan ".concat(expiration_days, " d\xEDas hasta la expiraci\xF3n."));
      var params = {
        bcase: [{
          'business_name': this.useCaseRequest.business_name,
          organization: this.userDomain,
          'company_name': this.companyName,
          company_abrev: this.companyAbrevs[this.companyCode],
          'owner_name': this.userEmail,
          'env_user_group': this.useCaseRequest.env_user_group,
          'env_user_admin_group': this.env_user_admin_group,
          'access_deadline_date': this.useCaseRequest.access_deadline_date,
          'description_business': this.useCaseRequest.description_business,
          business_area_id: null,
          'flag_data_ext': this.useCaseRequest.baseIDS ? '1' : '0',
          'stage_type_id': null,
          partyid_match: null
        }],
        rdetail: this.useCaseRequest.attributes,
        barea: [{
          company_name: this.companyName,
          name: null
        }],
        apstatus: [{
          company_name: this.companyName,
          // Solicitud de id 1: Solicitud de creación de Sandbox
          solicitude_type_id: 1
        }],
        source: this.companyCode === '000' ? 'ATHENA' : 'BIGQUERY',
        expiration_days: expiration_days
      };
      var technicalName = this.useCaseRequest.business_name.toLowerCase().split(' ').join('_');
      return UseCasesService.createUseCaseRequest(this.companyCode, technicalName, params).then(function (response) {
        // const data = response.data
        // const useCaseId = data.register_info.usecase_id
        if (!params.rdetail) {
          params.rdetail = [];
        }
        if (_this3.$gtm.enabled() && window.dataLayer) {
          window.dataLayer.push({
            event: GA_EVENTS.CREATE_SANDBOX,
            sandbox_name: params.bcase[0].business_name,
            sandbox_company: params.bcase[0].company_abrev,
            owner_email: _this3.stringToHash(params.bcase[0].owner_name),
            company_code: _this3.companyCode,
            attribute_count: params.rdetail.length,
            hash_email: _this3.stringToHash(userInfo.email),
            module: 'attributes_marketplace'
          });
        }

        // this.updateUseCaseRequest({ property: 'usecase_id', value: useCaseId })
        _this3.setShowLoading(false);
      }).catch(function (error) {
        throw error;
      });
    },
    save: function save(date) {
      this.$refs.menu.save(date);
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    onOpenModalUseCase: function onOpenModalUseCase(item, modalName) {
      this.useCase = item;
      this.openDialog(modalName);
    },
    precargarOwner: function precargarOwner() {
      this.newUsers.push(this.userEmail.toLowerCase());
    },
    precargarAdmins: function precargarAdmins() {
      var _this4 = this;
      var envUserAdminGroup = {
        email: {}
      };
      var clauses = {};
      clauses.roles = this.ATRIBUTE_ADMIN;
      var parametros = {
        domain: this.INTERCORP_DOMAIN,
        limit: 100,
        page: 1,
        clauses: clauses
      };
      rolesService.getRoles(parametros).then(function (response) {
        response.data.result.forEach(function (item, index) {
          envUserAdminGroup['email'][index.toString()] = item.email;
        });
        _this4.env_user_admin_group = envUserAdminGroup;
      });
    },
    changeEmail: function changeEmail() {
      this.newUsers.push(this.userEmail.toLowerCase().trim());
      this.newUsers = this.newUsers.map(function (name) {
        return name.toLowerCase().trim();
      });
      this.newUsers = _toConsumableArray(new Set(this.newUsers));
    }
  })
};